// Replaces the browser's persistent storage with in-memory copies before any
// app module runs. Every save path in the app (Dexie, crash recovery, settings,
// the key store, fonts) keeps working unchanged, but writes only to this
// tab's memory, so closing or refreshing the tab erases everything.
//
// Must be the first import of main-demo.ts: Dexie captures `indexedDB` when
// its module is evaluated.
import 'fake-indexeddb/auto'

class MemoryStorage implements Storage {
  private items = new Map<string, string>()

  get length(): number {
    return this.items.size
  }

  key(index: number): string | null {
    return [...this.items.keys()][index] ?? null
  }

  getItem(key: string): string | null {
    return this.items.get(String(key)) ?? null
  }

  setItem(key: string, value: string): void {
    this.items.set(String(key), String(value))
  }

  removeItem(key: string): void {
    this.items.delete(String(key))
  }

  clear(): void {
    this.items.clear()
  }
}

for (const name of ['localStorage', 'sessionStorage'] as const) {
  Object.defineProperty(window, name, {
    value: new MemoryStorage(),
    configurable: true,
    enumerable: true,
    writable: false,
  })
}
